import { Component, EventEmitter, Input, Optional, Output } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { LocalStorageService } from '../../services/local-storage.service';

export interface EventAmount {
	event: 'decrease' | 'increase';
	value: number;
}

@Component({
    selector: 'app-amount',
    templateUrl: './amount.component.html',
    styleUrls: ['./amount.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective,
        },
    ],
    standalone: false
})
export class AmountComponent {
	@Input() controlName!: string;
	@Input() disabled: boolean = false;
	@Output() changeAmount = new EventEmitter<EventAmount>();
	public clientType: number = 0;
	constructor(
		@Optional() private controlContainer: ControlContainer,
		private localStorage: LocalStorageService
	) {
		this.clientType = Number(localStorage.getItem('ROD-simulation.clientType'));
	}

	get form(): UntypedFormGroup {
		return this.controlContainer.control as UntypedFormGroup;
	}

	get control(): UntypedFormControl {
		return this.form.get(this.controlName) as UntypedFormControl;
	}

	decrease() {
		this.control.setValue(this.control.value > 1 ? this.control.value - 1 : this.control.value);
		this.emitEvent('decrease');
	}

	increase() {
		let maximumValue = 0;
		if (this.clientType === 1) {
			maximumValue = 20;
		} else if (this.clientType === 3) {
			maximumValue = 200;
		} else {
			maximumValue = 3;
		}
		this.control.setValue(this.control.value < maximumValue ? this.control.value + 1 : this.control.value);
		this.emitEvent('increase');
	}

	emitEvent(event: 'decrease' | 'increase'): void {
		this.changeAmount.next({
			event: event,
			value: this.control.value,
		});
	}
}
